<template>
	<div class="sliders__block__child slider">
		<!-- v-if="window.width > 1366" -->
		<div class="swiper-container big-swiper">
			<div class="swiper-wrapper">
				<div
					class="swiper-slide"
					v-for="(slide, index) in JSON.parse(slides)"
					:key="index"
				>
					<img :src="slide.image" alt="" />
					
				</div>
			</div>

			<div class="swiper-nav">
				<div class="swiper-button-prev-testimonial">
					<img :src="prev_icon" alt="play" />
				</div>
				<div class="swiper-button-next-testimonial">
					<img :src="next_icon" alt="play" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';
Swiper.use([Navigation, Pagination, Autoplay]);

export default {
	data() {
		return {
			bigSlider: null,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		slides: {},
		title: {},
		next_icon: {},
		prev_icon: {},
	},

	computed: {},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {
		// eslint-disable-next-line no-unused-vars
		this.bigSlider = new Swiper('.swiper-container', {
			// Optional parameters
			speed: 400,
			direction: 'horizontal',
			loop: false,
			autoHeight: false,
			autoplay: {
				delay: 3000,
			},
			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next-testimonial',
				prevEl: '.swiper-button-prev-testimonial',
			},
		});
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

/* write SCSS here */

.slider {
	background-color: #212121;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	padding: 0;
	width: 100%;
	height: auto;
}

.swiper-container {
	width: 100%;
	height: 100%;
	position: relative;

	.swiper-wrapper {
		height: 100% !important;

		@media (max-width: 1366px) {
			height: 500px;
		}

		.swiper-slide {
			height: 100%;
		
			column-gap: 0;
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center center;

			@media (max-width: 1366px) {
				height: 100%;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
	}
}

.swiper-nav {
	position: absolute;
	z-index: 100;
	top: 50%;
	transform: translateY(-50%);
	width: calc(100% - 50px);
	display: flex;
	justify-content: space-between;

	@media (max-width: 1366px) {
		display: none;
	}

	.swiper-button-prev-testimonial,
	.swiper-button-next-testimonial {
		display: flex;
		margin-left: 50px;

		img {
			height: 40px;
		}
	}
}
</style>





// WEBPACK FOOTER //
// resources/assets/scripts/vue/ImageSlider.vue